/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const listingTypeSlice = createSlice({
	name: 'listingType',
	initialState: '',
	reducers: {
		setListingType(state, action) {
			return action.payload;
		}
	}
});

export const { setListingType } = listingTypeSlice.actions;
export default listingTypeSlice.reducer;
